(() => {
  const colors = {
    black:'#151515',white:'#fff',navy:'#202a44','dark navy':'#192437','heather dark navy':'#343b4a',red:'#b7242d','true red':'#c62430',cardinal:'#8d2435',maroon:'#652c40',burgundy:'#652c40',wine:'#722f44',crimson:'#a83c45',scarlet:'#c72435',pink:'#f2a3b8','light pink':'#f1c9d3','sport pink':'#e78eac',blossom:'#ffe4ec',azalea:'#dc608d',heliconia:'#d94b8b',berry:'#99516e',orchid:'#ac85b3',purple:'#563d70','team purple':'#593a75',lavender:'#b4a0cb',violet:'#a0a0c6',lilac:'#c7b0cc',blue:'#3775a2','royal blue':'#23549b',royal:'#23549b','columbia blue':'#7babc8','light blue':'#b0cbdc','carolina blue':'#79a9cf','indigo blue':'#526b85',denim:'#587286',iceblue:'#c1dbe7','ice blue':'#c1dbe7',granite:'#87888a',grey:'#939597',gray:'#939597','sport grey':'#b2b3b5','sport gray':'#b2b3b5','heather grey':'#a5a7aa','heather gray':'#a5a7aa','dark heather':'#55565b','graphite heather':'#66696d','dark grey':'#4e5053','dark gray':'#4e5053',charcoal:'#4b4d50',pepper:'#565652',ash:'#d4d5d7',silver:'#c1c4c8',green:'#39785a','forest green':'#244b3c',forest:'#244b3c','hunter green':'#15392f',hunter:'#15392f','military green':'#656b50',military:'#656b50','irish green':'#228e55','kelly green':'#25854b',kelly:'#25854b',moss:'#68715c',loden:'#60694d',olive:'#6a704c',sage:'#a2ad98','blue spruce':'#506c64','grass green':'#467c42',emerald:'#24745b',mint:'#a4d5bd',teal:'#2f7b80',seafoam:'#88b6ab','sea foam':'#88b6ab',sand:'#d7c7ad',natural:'#eee4cd',ivory:'#f0eadb',cream:'#f1e8d5',khaki:'#b6a582',tan:'#bca383',beige:'#d9c9ad',stone:'#d1c8b5',brown:'#674b3b','dark chocolate':'#493c34',chocolate:'#654637',espresso:'#53463f',mustard:'#c1a14a',gold:'#e5b841',yellow:'#f3d55b',daisy:'#f4db54',orange:'#e17d3a',rust:'#aa563d',terracotta:'#b76851',peach:'#f3bb9d','burnt orange':'#bd653d',safetyorange:'#ee7c2d','safety orange':'#ee7c2d',safetygreen:'#c9de39','safety green':'#c9de39','vintage black':'#363638','washed black':'#454543','heather black':'#424244','heather navy':'#3d4b60','charcoal heather':'#57595c',heather:'#a5a7aa'
  };
  Object.assign(colors, {"asphalt":"#45494b","athletic heather":"#b7b7b6","baby pink":"#f4c5d4","bay":"#aec3b0","birch":"#e2dbc9","black heather":"#383b3d","black melange":"#333639","blue jean":"#7c91a4","bone":"#e7dfce","carbon grey":"#b8b7b2","chambray":"#a7bdc8","collegiate navy":"#1d2c45","collegiate navy melange":"#34445a","collegiate royal":"#2757a6","collegiate royal melange":"#3b609b","cranberry":"#922c43","evergreen":"#254f43","green camo":"#636b4c","grey one heather":"#d0d1d0","grey three":"#909394","heather columbia blue":"#78a4c0","heather dust":"#d9cfb9","heather forest":"#4f695a","heather ice blue":"#c0d9df","heather orange":"#d78853","heather orchid":"#c8b0c7","heather red":"#b34e58","heather slate":"#576e7e","heather sport dark navy":"#3a4354","heather true royal":"#3b639d","multicam black":"#313a32","navy blazer":"#263040","neon pink":"#ec5d9a","soft pink":"#f2c8d1","solid white blend":"#f8f8f5","spruce":"#2b554b","steel blue":"#4f7085","true royal":"#28549b","vintage white":"#eeeadd"});
  const normalized = value => String(value).trim().toLowerCase().replace(/\s+/g,' ');
  function swatchBackground(name, nativeColor, nativeImage, twoTone = false) {
    const parts = normalized(name).split('/').map(v=>v.trim());
    const primary = colors[parts[0]];
    // Two-tone cap names may list the bill first (Royal/Natural).
    // Resolve the full combination before Shopify's single-color fallback.
    if (parts.length === 2 && (twoTone || parts.includes('natural')) && colors[parts[0]] && colors[parts[1]]) {
      const halves = parts.includes('natural') ? ['natural', parts.find(v=>v!=='natural') || 'natural'] : parts;
      return `linear-gradient(90deg, ${colors[halves[0]]} 0 50%, ${colors[halves[1]]} 50% 100%)`;
    }
    if (nativeColor) return nativeColor;
    if (nativeImage) return `url("${nativeImage.replace(/["\\\n\r]/g,'')}")`;
    return primary || null;
  }
  function resolveVariant(variants, selected, index, value) {
    const desired = selected.map((v,i)=>i===index?value:v);
    return variants.find(v=>v.available && v.options.every((o,i)=>o===desired[i])) || variants.find(v=>v.available && v.options[index]===value) || variants.find(v=>v.options.every((o,i)=>o===desired[i])) || variants.find(v=>v.options[index]===value);
  }
  // Pure functions are also exposed for local behavioral checks.
  if (typeof module !== 'undefined' && module.exports) { module.exports={swatchBackground,resolveVariant}; return; }
  function readVariants(root){return JSON.parse(root.querySelector('[data-swatch-variants]').textContent);}
  function init(root) {
    root.querySelectorAll('[data-color-name]').forEach(chip=>{
      const bg=swatchBackground(chip.dataset.colorName,chip.dataset.nativeColor,chip.dataset.nativeImage,chip.hasAttribute('data-two-tone'));
      const control=chip.closest('.tag-swatch');
      if(bg) {
        chip.style.background=bg;
        delete chip.dataset.unmapped;
        chip.textContent='';
        control?.classList.remove('tag-swatch--named');
      } else {
        // New, unmapped shades remain explicit rather than displaying a fake color.
        chip.textContent=chip.dataset.colorName;
        control?.classList.add('tag-swatch--named');
      }
    });
    root.querySelectorAll('[data-variant-picker]').forEach(picker=>{
      if(picker.dataset.ready)return;
      const form=picker.closest('form'), select=form.querySelector('[data-product-select]');
      if(!select)return;
      const variants=readVariants(picker), fields=[...picker.querySelectorAll('[data-option-index]')];
      const sizeField=picker.querySelector('[data-size-option]');
      const requiresSize=!!sizeField;
      let chosenSize=null;
      // Preserve color/variant deep links while requiring an explicit size tap.
      if(requiresSize && !select.value) {
        const first=variants.find(v=>String(v.id)===select.dataset.initialVariantId)
          || variants.find(v=>v.available) || variants[0];
        if(first)select.value=String(first.id);
      }
      const sync=()=>{
        const variant=variants.find(v=>String(v.id)===select.value); if(!variant)return;
        picker.dataset.sizeChosen=String(!requiresSize || chosenSize!==null);
        fields.forEach(field=>{
          const i=Number(field.dataset.optionIndex);
          const isUnchosenSize=field.hasAttribute('data-size-option') && chosenSize===null;
          field.querySelector('[data-option-label]').textContent=isUnchosenSize?'Choose a size':variant.options[i];
          field.querySelectorAll('[data-option-value]').forEach(button=>{
            const value=button.dataset.optionValue;
            button.setAttribute('aria-pressed',String(!isUnchosenSize && value===variant.options[i]));
            if(!field.hasAttribute('data-color-option'))button.disabled=!variants.some(v=>v.available && v.options.every((o,j)=>o===(j===i?value:variant.options[j])));
          });
        });
        picker.querySelector('[data-variant-status]').textContent=requiresSize && chosenSize===null ? 'Choose a size to continue' : variant.options.join(' / ')+(variant.available?'':' — Sold out');
        const prompt=form.querySelector('[data-size-prompt]');
        if(prompt)prompt.hidden=chosenSize!==null;
      };
      picker.addEventListener('click',event=>{
        const button=event.target.closest('[data-option-value]');if(!button||button.disabled)return;
        const current=variants.find(v=>String(v.id)===select.value)||variants.find(v=>v.available)||variants[0], field=button.closest('[data-option-index]');
        if(!current||!field)return;
        const variant=resolveVariant(variants,current.options,Number(field.dataset.optionIndex),button.dataset.optionValue);
        if(variant){
          if(requiresSize){
            const sizeIndex=Number(sizeField.dataset.optionIndex);
            if(field===sizeField)chosenSize=variant.options[sizeIndex];
            else if(chosenSize!==null && variant.options[sizeIndex]!==chosenSize)chosenSize=null;
            picker.dataset.sizeChosen=String(chosenSize!==null);
          }
          select.value=String(variant.id);
          // Set the selected-size state before the theme's change handler reads it.
          sync();
          select.dispatchEvent(new Event('change',{bubbles:true}));
          const label=form.querySelector('[data-add-label]');
          const add=form.querySelector('[data-add-to-bag]');
          if(requiresSize && chosenSize===null){
            if(add)add.disabled=true;
            if(label)label.textContent='Choose a size';
          }
        }
      });
      select.addEventListener('change',sync);sync();
      select.hidden=true;
      const label=form.querySelector(`label[for="${CSS.escape(select.id)}"]`);if(label)label.hidden=true;
      picker.hidden=false;picker.dataset.ready='true';
      if(requiresSize){
        const add=form.querySelector('[data-add-to-bag]');
        const addLabel=form.querySelector('[data-add-label]');
        if(add)add.disabled=true;
        if(addLabel)addLabel.textContent='Choose a size';
      }
    });
    // Start nearby desktop alternate images *before* hover, so the first
    // mouseover is responsive. Touch devices download none of these images.
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const hoverLoaders = new WeakMap();
    const hoverObserver = canHover && 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            hoverLoaders.get(entry.target)?.();
            hoverObserver.unobserve(entry.target);
          });
        }, { rootMargin: '320px 0px' })
      : null;
    root.querySelectorAll('[data-swatch-card]').forEach(card => {
      if (card.dataset.cardHoverReady) return;
      card.dataset.cardHoverReady = 'true';
      const hoverImage = card.querySelector('[data-tag-card-hover]');
      const media = card.querySelector('.product-card__media');
      if (!canHover || !hoverImage || !media) return;
      let loading = false;
      const loadHover = () => {
        if (card.classList.contains('is-swatch-changed') || card.classList.contains('is-hover-ready') || loading) return;
        loading = true;
        hoverImage.addEventListener('load', () => {
          loading = false;
          if (!card.classList.contains('is-swatch-changed')) card.classList.add('is-hover-ready');
        }, { once: true });
        hoverImage.addEventListener('error', () => { loading = false; }, { once: true });
        hoverImage.src = hoverImage.dataset.hoverSrc;
      };
      // Hover remains the fallback when someone moves the mouse to a card
      // before its nearby-image preload has completed.
      media.addEventListener('pointerenter', loadHover, { passive: true });
      if (hoverObserver) {
        hoverLoaders.set(media, loadHover);
        hoverObserver.observe(media);
      }
    });

    root.querySelectorAll('[data-swatch-card]').forEach(card=>{
      const group=card.querySelector('[data-card-color-index]');if(!group||card.dataset.swatchesReady)return;
      const variants=readVariants(card),i=Number(group.dataset.cardColorIndex);
      let current=variants.find(v=>v.available)||variants[0];
      group.addEventListener('click',event=>{
        const swatch=event.target.closest('[data-card-color]');if(!swatch||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const variant=resolveVariant(variants,current.options,i,swatch.dataset.cardColor);if(!variant)return;
        event.preventDefault();current=variant;
        // Protect the shopper's selected variant color from a mismatched
        // secondary mockup in the desktop hover preview.
        card.classList.add('is-swatch-changed');
        card.classList.remove('is-hover-ready');
        group.querySelectorAll('[data-card-color]').forEach(a=>a.setAttribute('aria-current',String(a===swatch)));
        const image=card.querySelector('.product-card__media img');
        if(image&&variant.image){image.src=variant.image;image.srcset='';image.alt=card.querySelector('.product-card__title').textContent.trim()+' — '+swatch.dataset.cardColor;}
        card.querySelectorAll('.product-card__visual > a,.product-card__title a,.product-card__quick a').forEach(a=>{const url=new URL(a.href);url.searchParams.set('variant',variant.id);a.href=url;});
        const id=card.querySelector('input[name="id"]');if(id)id.value=variant.id;
        const add=card.querySelector('button[name="add"]');if(add){add.disabled=!variant.available;add.textContent=variant.available?'+ Quick add':'Sold out';}
        const price=card.querySelector('.price');if(price){price.replaceChildren();if(variant.comparePrice){const old=document.createElement('s');old.textContent=variant.comparePrice;price.append(old,document.createTextNode(' '));}const amount=document.createElement('span');amount.textContent=variant.price;price.append(amount);}
      });card.dataset.swatchesReady='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
